import browse from './browse.vue';
import category from './category-or-food/category.vue';
import food from './category-or-food/food.vue';
import read from './read.vue';

export default { browse, read, food, category };
